




















import { defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'

import useI18n from '@/composables/use-i18n'
import useProxyValue from '@/composables/use-proxy-value'

import SearchFilter, { SortMethod } from '@/classes/SearchFilter'

type SortMethodItem = { name: string, value: SortMethod }

export default defineComponent({
  props: {
    value: {
      type: String as PropType<SortMethod>,
      default: SearchFilter.defaultSortMethod,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'' | 'select'>,
      default: '',
    },
    list: {
      type: Array as PropType<SortMethodItem[]>,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const i18n = useI18n()
    const label = i18n.t('sortMethod.label')

    const { proxyValue } = useProxyValue(toRefs(props).value, emit)

    watch(proxyValue, (value) => {
      emit('update', value)
    }, { immediate: true })

    return {
      proxyValue,
      label,
    }
  },
})
